export default {
  mounted() {
    this.el.addEventListener("keydown", e => {
      if (e.key === "Enter" && !e.shiftKey) {
        const okButton = document.querySelector("button[data-action='default']")
        if (okButton) {
          e.preventDefault()
          okButton.click()
        }
      }
    })
  }
}
